import React, { Component } from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Check from "@material-ui/icons/Check";

import CustomizedParameters from "./CustomizedParameters";

const styles = theme => ({
  container: { minWidth: "35em", marginLeft: "1em", marginBottom: "1em" },
  rightAlignedCell: { textAlign: "center" },
  boldCell: { fontWeight: "bold" },
  icon: { margin: theme.spacing.unit, fontSize: 32, color: "#2196f3" },
  column: {
    display: "flex",
    "flex-direction": "column"
  }
});

class PeriodizationAside extends Component {
  render() {
    const { classes, record } = this.props;
    if (!record) return null;
    const { periodization } = record;
    return (
      <div className={classes.column}>
        <Paper className={classes.container}>
          <div>
            <Typography variant="h4" className={classes.rightAlignedCell}>
              Periodization
            </Typography>
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Monday</TableCell>
                <TableCell>Tuesday</TableCell>
                <TableCell>Wednesday</TableCell>
                <TableCell>Thursday</TableCell>
                <TableCell>Friday</TableCell>
                <TableCell>Saturday</TableCell>
                <TableCell>Sunday</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {periodization.includes("mon") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
                <TableCell>
                  {periodization.includes("tue") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
                <TableCell>
                  {periodization.includes("wed") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
                <TableCell>
                  {periodization.includes("thu") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
                <TableCell>
                  {periodization.includes("fri") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
                <TableCell>
                  {periodization.includes("sat") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
                <TableCell>
                  {periodization.includes("sun") && (
                    <Check className={classes.icon} />
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <CustomizedParameters record={record} />
      </div>
    );
  }
}

export default withStyles(styles)(PeriodizationAside);
